import { useState } from 'react'
import { Group, UnstyledButton } from '@mantine/core'

// #1080 職種/工程/こだわり など項目数が少ない複数選択。チェックボックスの一覧ではなく、
// クリックで選択が切り替わるチップで一覧性と操作性を上げる。
// 送信は hidden input(name[]=value)で既存のRailsフォームに任せる。
export default function ChipToggleGroup({ fieldName, options = [], initialValues = [] }) {
  const [selected, setSelected] = useState(() => new Set(initialValues.map(String)))

  const toggle = (value) => {
    setSelected((prev) => {
      const next = new Set(prev)
      if (next.has(value)) next.delete(value)
      else next.add(value)
      return next
    })
  }

  return (
    <div className="chip-toggle-group" role="group">
      <input type="hidden" name={fieldName} value="" />
      {[...selected].map((v) => (
        <input key={v} type="hidden" name={fieldName} value={v} />
      ))}

      <Group gap={8}>
        {options.map((o) => {
          const active = selected.has(String(o.value))
          return (
            <UnstyledButton
              key={o.value}
              type="button"
              role="checkbox"
              aria-checked={active}
              onClick={() => toggle(String(o.value))}
              className={`chip-toggle${active ? ' is-active' : ''}`}
            >
              {active && <span className="material-icons chip-toggle_check" aria-hidden="true">check</span>}
              {o.label}
            </UnstyledButton>
          )
        })}
      </Group>
    </div>
  )
}
